import React from 'react';

import { Container } from './styles';

const Main = ({ children, sidebar, style }) => <Container sidebar={sidebar} style={style || {}}>{children}</Container>;

export default Main;
